import { useTranslation } from "react-i18next";
import { IonRouterLink } from "@ionic/react";
import { Link } from "react-router-dom";

export const Footer = ({ alt, notAuthenticated }) => {
  const { t } = useTranslation();
  const linkClass = alt ? "footer-text-alt" : "footer-text";

  const isStandalonePwa = () => {
    if (typeof window === "undefined") {
      return false;
    }

    const mediaStandalone =
      typeof window.matchMedia === "function" &&
      window.matchMedia("(display-mode: standalone)").matches;

    const iosStandalone =
      typeof window.navigator !== "undefined" &&
      "standalone" in window.navigator &&
      window.navigator.standalone;

    const launchedFromAndroidApp =
      typeof document !== "undefined" &&
      typeof document.referrer === "string" &&
      document.referrer.startsWith("android-app://");

    return Boolean(mediaStandalone || iosStandalone || launchedFromAndroidApp);
  };

  const openExternal = (url) => {
    if (typeof window === "undefined") {
      return false;
    }

    if (!isStandalonePwa()) {
      return false;
    }

    try {
      const constructedUrl = new URL(url, window.location.origin);
      constructedUrl.searchParams.set("fromApp", "1");

      window.location.assign(constructedUrl.toString());
      return true;
    } catch (error) {
      return false;
    }
  };

  return (
    <>
      <div className="separator"></div>

      {/* <p className={alt ? "footer-text-alt" : "footer-text"}>
        <Link
          className={alt ? "footer-text-alt" : "footer-text"}
          to="/about/policy#terms"
        >
          {t("footer.terms")}
        </Link>
        {" · "}
        <Link
          className={alt ? "footer-text-alt" : "footer-text"}
          to="/about/policy#policy"
        >
          {t("footer.privacy")}
        </Link>
        {!notAuthenticated && (
          <>
            {" · "}
            <Link
              className={alt ? "footer-text-alt" : "footer-text"}
              to="/about/about"
            >
              {t("footer.about")}
            </Link>
            {" · "}
            <Link
              to="/about/policy#support"
              className={alt ? "footer-text-alt" : "footer-text"}
            >
              {t("footer.help")}
            </Link>
          </>
        )}
      </p> */}
      <p className={linkClass}>
        <Link className={linkClass} to="/terms-of-service">
          {t("footer.terms")}
        </Link>
        {" · "}
        <Link className={linkClass} to="/privacy-policy">
          {t("footer.privacy")}
        </Link>
        {!notAuthenticated && (
          <>
            {" · "}
            <Link to="/contact-us" className={linkClass}>
              {t("footer.help")}
            </Link>
          </>
        )}
        <small
          style={{
            display: "block",
            marginTop: "0.5rem",
            marginRight: "auto",
            marginLeft: "auto",
          }}
        >
          🇨🇦 Patent Pending · CIPO 3292395
        </small>
      </p>
      {/* <p className={alt ? "footer-text-alt" : "footer-text"}>
        &copy; {new Date().getFullYear()} LoonLog Inc.
      </p> */}
    </>
  );
};

export const SupportPageFooter = () => {
  const footerStyle = {
    backgroundColor: "#fafafa",
    color: "#000000",
    padding: "1.5rem 0",
    textAlign: "center",
    fontSize: "14px",
    marginTop: "2rem",
  };

  const copyrightStyle = {
    marginTop: "12px",
    opacity: "0.8",
  };

  return (
    <footer style={footerStyle}>
      {/* <div>
        <Link
          href="/terms"
          style={linkStyle}
          onMouseEnter={(e) =>
            (e.currentTarget.style.color = linkHoverStyle.color)
          }
          onMouseLeave={(e) => (e.currentTarget.style.color = linkStyle.color)}
        >
          Terms of Service
        </Link>
        <span>|</span>
        <Link
          href="/privacy"
          style={linkStyle}
          onMouseEnter={(e) =>
            (e.currentTarget.style.color = linkHoverStyle.color)
          }
          onMouseLeave={(e) => (e.currentTarget.style.color = linkStyle.color)}
        >
          Privacy Policy
        </Link>
      </div> */}
      <div style={copyrightStyle}>
        &copy; {new Date().getFullYear()} LOONLOG INC. All rights reserved.
      </div>
    </footer>
  );
};

